import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FullScreenVideoPlayerComponent } from './full-screen-video-player.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [FullScreenVideoPlayerComponent],
  exports: [FullScreenVideoPlayerComponent]
})
export class FullScreenVideoPlayerComponentModule { }